import GaiaPlusPage from './GaiaPlusPage'

export default GaiaPlusPage
// eslint-disable-next-line import/export
export * from './GaiaPlusPage'
